export class AssociateError extends Error {
  constructor (msg: string, asserter = undefined) {
    super(msg)
    Error.captureStackTrace?.(this, asserter || this.constructor)
  }
}
